module.exports = __webpack_public_path__ + "static/media/320x100_0004_en.fc326aa2.jpg";